import {
  LegalEntitiesUpdateInvoiceCcEmailsRequestType,
  LegalEntitiesUpdateInvoiceCcEmailsResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useLegalEntityUpdateInvoiceCcEmails = (legalEntityId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: async (data: LegalEntitiesUpdateInvoiceCcEmailsRequestType) => {
      return apiV2Request({
        user,
        business,
        method: "put",
        path: `legal-entity/${legalEntityId}/invoice-cc-emails`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as LegalEntitiesUpdateInvoiceCcEmailsResponseType,
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.LegalEntity],
      });
    },
  });
};
